<a #link
   (click)="onClick(value)"
   tabindex="0"
   aria-hidden="true"
   role="option"
   [attr.aria-label]="label"
   [class.selected]="(selectControlRegistry.activeItem$ | async) === this"
   [class.--is-child]="isChild"
   [class.--is-large]="isLarge"
>
    @if (image) {
        <img [src]="image"
             alt="{{ label }}"
             class="option-image"
        />
    }

    {{ label }}
</a>
